export const IDEATION_PHASE_NAMES = {
    1: 'Explore',
    2: 'Shape',
    3: 'Define',
    4: 'Surface',
    5: 'Structure',
    6: 'Polish',
};
export const IDEATION_PHASE_DESCRIPTIONS = {
    1: 'Product concepts and visions',
    2: 'System mechanisms and operating models',
    3: 'Specific user-facing features (medium-agnostic)',
    4: 'Delivery context and touchpoint',
    5: 'Information hierarchy and layout skeleton',
    6: 'Smart UX details and micro-copy',
};
export const NON_UI_PHASE_NAMES = {
    4: 'Delivery',
    5: 'Touchpoints',
    6: 'Trust',
};
export const NON_UI_PHASE_DESCRIPTIONS = {
    4: 'Operational process or physical mechanism that delivers the value',
    5: 'Specific human moments of contact with the operational system',
    6: 'Signals that make stakeholders confident the system works reliably',
};
/**
 * Get the next phase for child nodes
 * Phase progresses: 1 → 2 → 3 → 4 → 5 → 6 → 6 (stays at 6)
 */
export function getNextPhase(currentPhase) {
    if (!currentPhase) {
        return 1;
    }
    const nextPhase = Math.min(currentPhase + 1, 6);
    return nextPhase;
}
